import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../hacks.mjs';
import { EmptyIterator_instancex3sopkoseugu as EmptyIterator_instance } from '../collections/CollectionsKt.mjs';
import { ConstrainedOnceSequence3d7vfvt49occh as ConstrainedOnceSequence } from './sequenceJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function generateSequence(seed, nextFunction) {
  var tmp;
  if (seed == null) {
    tmp = EmptySequence_instance;
  } else {
    tmp = new (GeneratorSequence())(() => seed, nextFunction);
  }
  return tmp;
}
function generateSequence_0(nextFunction) {
  return constrainOnce(new (GeneratorSequence())(nextFunction, (it) => nextFunction()));
}
function emptySequence() {
  return EmptySequence_instance;
}
var DropTakeSequenceClass;
function DropTakeSequence() {
  if (DropTakeSequenceClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'DropTakeSequence');
    DropTakeSequenceClass = $;
  }
  return DropTakeSequenceClass;
}
var TakeSequence$iterator$1Class;
function TakeSequence$iterator$1() {
  if (TakeSequence$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.ol_1 = this$0.rl_1;
        this.pl_1 = this$0.ql_1.p1();
      }
      r1() {
        if (this.ol_1 === 0)
          throw NoSuchElementException().u6();
        this.ol_1 = this.ol_1 - 1 | 0;
        return this.pl_1.r1();
      }
      q1() {
        return this.ol_1 > 0 && this.pl_1.q1();
      }
    }
    initMetadataForClass($);
    TakeSequence$iterator$1Class = $;
  }
  return TakeSequence$iterator$1Class;
}
var TakeSequenceClass;
function TakeSequence() {
  if (TakeSequenceClass === VOID) {
    class $ {
      constructor(sequence, count) {
        this.ql_1 = sequence;
        this.rl_1 = count;
        // Inline function 'kotlin.require' call
        if (!(this.rl_1 >= 0)) {
          var message = 'count must be non-negative, but was ' + this.rl_1 + '.';
          throw IllegalArgumentException().o2(toString(message));
        }
      }
      u3(n) {
        return n >= this.rl_1 ? this : new (TakeSequence())(this.ql_1, n);
      }
      p1() {
        return new (TakeSequence$iterator$1())(this);
      }
    }
    initMetadataForClass($, 'TakeSequence', VOID, VOID, [DropTakeSequence()]);
    TakeSequenceClass = $;
  }
  return TakeSequenceClass;
}
function ensureItemIterator($this) {
  var itemIterator = $this.tl_1;
  if (!(itemIterator == null) && itemIterator.q1()) {
    $this.ul_1 = 1;
    return true;
  }
  while ($this.sl_1.q1()) {
    var element = $this.sl_1.r1();
    var nextItemIterator = $this.vl_1.yl_1($this.vl_1.xl_1(element));
    if (nextItemIterator.q1()) {
      $this.tl_1 = nextItemIterator;
      $this.ul_1 = 1;
      return true;
    }
  }
  $this.ul_1 = 2;
  $this.tl_1 = null;
  return false;
}
var FlatteningSequence$iterator$1Class;
function FlatteningSequence$iterator$1() {
  if (FlatteningSequence$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.vl_1 = this$0;
        this.sl_1 = this$0.wl_1.p1();
        this.tl_1 = null;
        this.ul_1 = 0;
      }
      r1() {
        if (this.ul_1 === 2)
          throw NoSuchElementException().u6();
        if (this.ul_1 === 0 && !ensureItemIterator(this)) {
          throw NoSuchElementException().u6();
        }
        this.ul_1 = 0;
        return ensureNotNull(this.tl_1).r1();
      }
      q1() {
        if (this.ul_1 === 1)
          return true;
        if (this.ul_1 === 2)
          return false;
        return ensureItemIterator(this);
      }
    }
    initMetadataForClass($);
    FlatteningSequence$iterator$1Class = $;
  }
  return FlatteningSequence$iterator$1Class;
}
var FlatteningSequenceClass;
function FlatteningSequence() {
  if (FlatteningSequenceClass === VOID) {
    class $ {
      constructor(sequence, transformer, iterator) {
        this.wl_1 = sequence;
        this.xl_1 = transformer;
        this.yl_1 = iterator;
      }
      p1() {
        return new (FlatteningSequence$iterator$1())(this);
      }
    }
    initMetadataForClass($, 'FlatteningSequence');
    FlatteningSequenceClass = $;
  }
  return FlatteningSequenceClass;
}
function calcNext($this) {
  while ($this.zl_1.q1()) {
    var item = $this.zl_1.r1();
    if ($this.cm_1.fm_1(item) === $this.cm_1.em_1) {
      $this.bm_1 = item;
      $this.am_1 = 1;
      return Unit_instance;
    }
  }
  $this.am_1 = 0;
}
var FilteringSequence$iterator$1Class;
function FilteringSequence$iterator$1() {
  if (FilteringSequence$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.cm_1 = this$0;
        this.zl_1 = this$0.dm_1.p1();
        this.am_1 = -1;
        this.bm_1 = null;
      }
      r1() {
        if (this.am_1 === -1) {
          calcNext(this);
        }
        if (this.am_1 === 0)
          throw NoSuchElementException().u6();
        var result = this.bm_1;
        this.bm_1 = null;
        this.am_1 = -1;
        return result;
      }
      q1() {
        if (this.am_1 === -1) {
          calcNext(this);
        }
        return this.am_1 === 1;
      }
    }
    initMetadataForClass($);
    FilteringSequence$iterator$1Class = $;
  }
  return FilteringSequence$iterator$1Class;
}
var FilteringSequenceClass;
function FilteringSequence() {
  if (FilteringSequenceClass === VOID) {
    class $ {
      constructor(sequence, sendWhen, predicate) {
        sendWhen = sendWhen === VOID ? true : sendWhen;
        this.dm_1 = sequence;
        this.em_1 = sendWhen;
        this.fm_1 = predicate;
      }
      p1() {
        return new (FilteringSequence$iterator$1())(this);
      }
    }
    initMetadataForClass($, 'FilteringSequence');
    FilteringSequenceClass = $;
  }
  return FilteringSequenceClass;
}
var EmptySequenceClass;
function EmptySequence() {
  if (EmptySequenceClass === VOID) {
    class $ {
      p1() {
        return EmptyIterator_instance;
      }
      u3(n) {
        return EmptySequence_instance;
      }
    }
    initMetadataForObject($, 'EmptySequence', VOID, VOID, [DropTakeSequence()]);
    EmptySequenceClass = $;
  }
  return EmptySequenceClass;
}
var EmptySequence_instance;
function EmptySequence_getInstance() {
  return EmptySequence_instance;
}
function calcNext_0($this) {
  $this.gm_1 = $this.hm_1 === -2 ? $this.im_1.jm_1() : $this.im_1.km_1(ensureNotNull($this.gm_1));
  $this.hm_1 = $this.gm_1 == null ? 0 : 1;
}
var GeneratorSequence$iterator$1Class;
function GeneratorSequence$iterator$1() {
  if (GeneratorSequence$iterator$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.im_1 = this$0;
        this.gm_1 = null;
        this.hm_1 = -2;
      }
      r1() {
        if (this.hm_1 < 0) {
          calcNext_0(this);
        }
        if (this.hm_1 === 0)
          throw NoSuchElementException().u6();
        var tmp = this.gm_1;
        var result = !(tmp == null) ? tmp : THROW_CCE();
        this.hm_1 = -1;
        return result;
      }
      q1() {
        if (this.hm_1 < 0) {
          calcNext_0(this);
        }
        return this.hm_1 === 1;
      }
    }
    initMetadataForClass($);
    GeneratorSequence$iterator$1Class = $;
  }
  return GeneratorSequence$iterator$1Class;
}
var GeneratorSequenceClass;
function GeneratorSequence() {
  if (GeneratorSequenceClass === VOID) {
    class $ {
      constructor(getInitialValue, getNextValue) {
        this.jm_1 = getInitialValue;
        this.km_1 = getNextValue;
      }
      p1() {
        return new (GeneratorSequence$iterator$1())(this);
      }
    }
    initMetadataForClass($, 'GeneratorSequence');
    GeneratorSequenceClass = $;
  }
  return GeneratorSequenceClass;
}
function constrainOnce(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ConstrainedOnceSequence()) {
    tmp = _this__u8e3s4;
  } else {
    tmp = new (ConstrainedOnceSequence())(_this__u8e3s4);
  }
  return tmp;
}
//region block: init
EmptySequence_instance = new (EmptySequence())();
//endregion
//region block: exports
export {
  DropTakeSequence as DropTakeSequence18qfczyunxcax,
  FilteringSequence as FilteringSequence3rfik2d45zn1y,
  FlatteningSequence as FlatteningSequence1gb46kmahgjp0,
  TakeSequence as TakeSequencecj2mz1r3ww35,
  emptySequence as emptySequence25zpp7hgtqwdd,
  generateSequence as generateSequence118suk3hffuuw,
  generateSequence_0 as generateSequence3b5pkcqrpr2fo,
};
//endregion

//# sourceMappingURL=Sequences.mjs.map
